<template>
  <app-layout>
    <div class="flex items-start max-w-7xl mx-auto p-10 space-x-4 bg-white rounded-md shadow-xl">
      <div class="w-full">
        <div class="flex">
          <h1 class="border-b border-dark-blue text-4xl">{{ $trans('app.coachs.my_account') }}</h1>
        </div>
        <div class="md:flex items-center mt-8">
          <BubbleButton @click="newInvitationDialogOpen = true"
                        v-if="!outOfCredits"
                        @mouseenter="handleToolTip"
                        @mouseleave="handleToolTip"
          >
            Nouvelle invitation
          </BubbleButton>
          <p class="text-sm text-red-500 font-bold w-full my-2"
             v-else
          >
            {{ $trans('app.coachs.out_of_credits') }}
          </p>
        </div>
        <div class="md:flex justify-between">
          <div class="w-full md:w-1/4 order-2">
            <div class="py-12 px-8 md:-mr-10 bg-dark-blue rounded-md md:rounded-tr-none md:rounded-br-none">
              <div>
                <div class="text-white text-xl mb-2">Crédits restant</div>
                <div class="text-3xl flex items-end text-white">
                  <span class="text-5xl font-bold mr-2" :class="outOfCredits ? 'text-red-500' : 'text-blue-200'">
                    {{ user.credits ?? 'XX' }}
                  </span> tests
                </div>
              </div>

              <div class="mt-12">
                <div class="text-white text-xl mb-2">Invitations envoyées</div>
                <div class="text-3xl flex items-end text-white"><span class="text-5xl font-bold text-blue-200 mr-2">{{ Object.keys(invitations).length }}</span> invitations</div>
              </div>

              <div class="mt-12">
                <div class="text-white text-xl mb-2">Tests réalisés</div>
                <div class="text-3xl flex items-end text-white"><span class="text-5xl font-bold text-blue-200 mr-2">{{ testsCompleted }}</span> tests</div>
              </div>
            </div>
          </div>
          <div class="w-full md:w-3/4 order-1 mt-8 pr-8">
            <coach-results-table :invitations="invitations"></coach-results-table>
          </div>
        </div>
      </div>
    </div>
    <MazDialog v-model="newInvitationDialogOpen" title="Nouvelle invitation">
      <NewInvitation />
    </MazDialog>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import CoachResultsTable from "@/Components/CoachResultsTable";
import MazDialog from "maz-ui/components/MazDialog";
import NewInvitation from "@/Components/NewInvitation";
import BubbleButton from "@/Components/BubbleButton";

export default {
  name: 'Account',
  components: {
    AppLayout,
    CoachResultsTable,
    MazDialog,
    NewInvitation,
    BubbleButton,
  },

  props: {
    'user': Object,
    'invitations': Object,
  },

  data() {
    return {
      newInvitationDialogOpen: false,
    }
  },

  computed: {
    testsCompleted() {
      return this.invitations.filter(i => i.hasBeenRedeemed).length;
    },

    outOfCredits() {
      return this.user.credits <= 0;
    }
  },
}
</script>
